import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../app/services/shared/interfaces';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../components/default/DefaultCard';

import DefaultModal from '../../components/default/DefaultModal';
import DefaultToolBar from '../../components/default/DefaultToolBar';
import ButtonCreate from '../../components/buttons/ButtonCreate';

import { toast } from 'react-toastify';

import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import { AppContext } from '../../contexts/AppContext';
import useItemCategoryService from '../../app/services/hooks/useItemCategoryService';
import { ItemCategory, ItemCategoryFilters } from '../../app/models/ItemCategory';

import { useHistory } from 'react-router-dom';
import ItemCategoryDataTable from './components/tables/ItemCategoryDataTable';
import ItemCategoryCreate from './components/ItemCategoryCreate';
import ItemCategoryEdit from './components/ItemCategoryEdit';
import useNavigationPage from '../../hooks/useNavigationPage';


const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Categorías',
        url: '/item-categories',
        isActive: true
    }
];

const ItemCategories = () => {
    const { navigationPage } = useNavigationPage();
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fetchingGetItemCategories, getItemCategories, deleteItemCategory, activeItemCategory } =
        useItemCategoryService();
    const [itemCategories, setItemCategories] = useState<ItemCategory[]>([]);

    const [itemCategoryIdEdit, setItemCategoryIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingCreate, setShowingCreate] = useState(false);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [itemCategoryFilter, setItemCategoryFilter] = useState<ItemCategoryFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'asc'
    });

    useEffect(() => {
        reloadTable();
    }, [itemCategoryFilter]);

    const getAllItemCategories = () => {
        getItemCategories(itemCategoryFilter, {
            onSuccess: (response: ServiceResponse) => {
                setItemCategories(response.data.item_categories);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message, {
                    autoClose: 2000
                });

                if (response.data.to_dashboard) {
                   navigationPage('/');
                }
            }
        });
    };

    const showEdit = (itemCategoryId: number) => {
        setShowingEdit(true);
        setItemCategoryIdEdit(itemCategoryId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setItemCategoryIdEdit(-1);
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const reloadTable = () => {
        getAllItemCategories();
    };

    const destroy = (itemCategoryId: number) => {
        const _text = 'Está a punto de eliminar la categoría #' + itemCategoryId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando categoría...');
                        deleteItemCategory(itemCategoryId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'la categoría no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };


    return (
        <>
            <Breadcrumbs pageSection="Categorías" breadcrumbs={breadcrumbs} />

            <DefaultCard>
                <DefaultToolBar
                    left={<ButtonCreate callbackCreate={showCreate} title="Nueva categoría" />}
                />
                <ItemCategoryDataTable
                    itemCategories={itemCategories}
                    edit={showEdit}
                    destroy={destroy}
                    loading={fetchingGetItemCategories}
                    filter={itemCategoryFilter}
                    setFilter={setItemCategoryFilter}
                    totalRows={totalRows}
                    callbackSuccess={reloadTable}
                />
            </DefaultCard>

            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear categoría"
                    backdrop={true}
                    showFooter={false}
                >
                    <ItemCategoryCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}

                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar categoría"
                    backdrop={true}
                    showFooter={false}
                >
                    <ItemCategoryEdit
                        itemCategoryId={itemCategoryIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={hideEdit}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default ItemCategories;
